module.exports = __webpack_public_path__ + "img/xsteacher-qrcode.a2a2e229.png";